import { connect } from 'react-redux'

import config from '../../config'
import ListerPage from '../../components/ListerPage/ListerPage'
import { BrowseHelper } from '../../helpers/BrowseHelper'
import { getCategoryNameFromFilter } from '../../selectors/categoryName'
import { updateDestinationPageType } from '../../redux/application/application'

const mapStateToProps = state => ({
  categoryAncestors: state.category.ancestors,
  categoryChildren: state.category.children,
  categoryName: state.category.categoryName,
  productsInCategoryTree: state.category.productsInCategoryTree,
  topLevelCategoryId: state.category.topLevelCategoryId,
  isPlp: state.category.isPlp,
  isPlpPlus: state.category.isPlpPlus,
  isPlpPlusDescendant: state.category.isPlpPlusDescendant,
  isClearance: state.application.isClearance,
  appliedFilters: state.product.appliedFilters,
  appliedFilterUriFragments: state.product.appliedFilterUriFragments,
  appliedSortBy: state.product.appliedSortBy,
  failedService: state.product.failedService,
  isCannedSearch: state.product.isCannedSearch,
  filterModalVisible: state.product.filterModalVisible,
  filters: state.product.filters,
  meta: state.product.meta,
  products: state.product.products,
  results: state.product.numberOfResults,
  searchTerm: state.product.searchTerm,
  filterResetCount: state.product.filterResetCount,
  ratingFilterApplied: state.product.ratingFilterApplied,
  noResultsModalVisible: !!state.product.noResultsModalVisible,
  spellcheckedSearch: state.product.spellcheckedSearch,
  searchType: state.product.searchType,
  inputSearchTerm: state.product.inputSearchTerm,
  searchTermSuggestions: state.product.searchTermSuggestions,
  brandSuggestions: state.product.brandSuggestions,
  categoryId: state.product.searchTerm ? state.product.categoryFilterId : state.category.categoryId,
  dfp: {
    channelId: config.dfp.channelId,
    taxonomy:
      state.application.searchTerm || state.category.isPlp
        ? BrowseHelper.getDfpListerQuery(
            state.application.pageType,
            state.application.searchTerm,
            state.category.categoryName
          )
        : BrowseHelper.getDfpTaxonomyQuery(state.category.ancestors, state.category.categoryName)
  },
  isPopulated: state.application.isPopulated || state.category.isPopulated,
  showErrorPage: state.application.showErrorPage,
  pageType: state.application.pageType,
  failureStatus: state.application.failureStatus,
  errorModalIsVisible: state.application.errorModalReason !== '',
  categoryNameFromFilter: getCategoryNameFromFilter(state)
})

const mapDispatchToProps = dispatch => {
  return {
    updateDestinationPageType: payload => dispatch(updateDestinationPageType(payload))
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(ListerPage)
